// assets/subscription-labels.js
function updateSubscriptionWidget(variant) {
  if (!variant || !variant.id) return;

  // get your full product JSON
  const raw = document.querySelector('[data-product-json]');
  if (!raw) return;
  const product = JSON.parse(raw.textContent);

  // find the matching variant record (so we can read its selling_plan_allocations)
  const current = product.variants.find(v => String(v.id) === String(variant.id));
  if (!current) return;

  // a helper to format cents → shop money string
  const fmt = cents => Shopify.formatMoney(cents);

  // 1) Update the TWO header-row prices
  const rows = document.querySelectorAll('.ShopifySubscriptionsWidget-row');
  if (rows.length >= 2) {
    // row[0] is the one-time header
    const oneTimePriceEl = rows[0].querySelector('.ShopifySubscriptionsWidget-price');
    if (oneTimePriceEl) oneTimePriceEl.textContent = fmt(variant.price);

    // row[1] is the “Subscribe Now” header
    const subPriceEl = rows[1].querySelector('.ShopifySubscriptionsWidget-price');
    const firstAlloc = current.selling_plan_allocations?.[0];
    if (subPriceEl && firstAlloc) subPriceEl.textContent = fmt(firstAlloc.price);
  }

  // 2) Update the “One-time purchase” radio label
  const oneTimeLabel = document.querySelector(
    '.ShopifySubscriptionsWidget-oneTime .Radio__LabelText'
  );
  if (oneTimeLabel) {
    const base = oneTimeLabel.textContent.split('—')[0].trim();
    oneTimeLabel.textContent = `${base} — ${fmt(variant.price)}`;
  }

  // 3) Update each “Deliver every …” radio label
  current.selling_plan_allocations?.forEach(allocation => {
    const planId = allocation.selling_plan_id;
    const radio = document.querySelector(
      `input[name="selling_plan"][value="${planId}"]`
    );
    if (!radio) return;
    const lbl = radio.closest('label')?.querySelector('.Radio__LabelText');
    if (!lbl) return;
    const base = lbl.textContent.split('—')[0].trim();
    lbl.textContent = `${base} — ${fmt(allocation.price)}`;
  });
}

// 4) Whenever a variant changes…
document.addEventListener('variant:change', e => {
  updateSubscriptionWidget(e.detail.variant);
});

// 5) …and on initial page load
document.addEventListener('DOMContentLoaded', () => {
  const defaultInput = document.querySelector('input[name="id"]');
  if (!defaultInput) return;
  const raw = document.querySelector('[data-product-json]');
  if (!raw) return;
  const product = JSON.parse(raw.textContent);
  const initial = product.variants.find(v => String(v.id) === defaultInput.value);
  updateSubscriptionWidget(initial);
});
